import * as React from "react";
import { useState } from "react";
import * as cn from "classnames/bind";
import { actionCreators } from "page/calendar/store";
import { actionCreators as eventActionCreators } from "event/store";
import * as styles from "./border-gallery.css";
import { ImageDetails, BorderOptions, CalendarState } from "burde";
import ZentaImagePickerV3 from "content/image/zenta-image-picker-v3";

const cx = cn.bind(styles);

const tabGroupCn = () =>
    cx({
        tabGroup: true,
    });

const tabGroupLiCn = () =>
    cx({
        tabGroupLi: true,
    });

const tabItemCn = (isSelected: boolean) =>
    cx({
        categoryTabItem: true,
        categoryTabItemSelected: isSelected,
    });

interface BorderGalleryProps {
    calendar: CalendarState;
    borderOptions: BorderOptions | null;
    borderImageId: number | null;
}

export const BorderGallery = (
    props: BorderGalleryProps &
        typeof actionCreators &
        typeof eventActionCreators,
) => {
    const {
        borderOptions,
        borderImageId,
        updateBorderImageId,
        updateUserHasChangedBorder,
        updateBorderColor,
    } = props;
    const [selectedTab, setSelectedTab] = useState(0);

    const changeBorder = (image: ImageDetails | null) => {
        updateUserHasChangedBorder(true);
        if (image !== null) {
            updateBorderColor(null);
            updateBorderImageId(image.id);
        } else {
            updateBorderImageId(null);
        }
    };

    return (
        <div>
            {borderOptions !== null && borderOptions.imageResources !== null ? (
                <div>
                    <ul className={tabGroupCn()}>
                        {borderOptions.imageResources.length > 1 &&
                            borderOptions.imageResources.map((item, index) => (
                                <li
                                    key={item.resourceGroupTitle}
                                    className={tabGroupLiCn()}>
                                    <a
                                        className={tabItemCn(
                                            index === selectedTab,
                                        )}
                                        onClick={() => setSelectedTab(index)}>
                                        {item.resourceGroupTitle}
                                    </a>
                                </li>
                            ))}
                    </ul>
                    <ZentaImagePickerV3
                        selectedImageId={borderImageId}
                        images={
                            borderOptions.imageResources[selectedTab].images
                        }
                        onClick={changeBorder}
                        borderPicker={true}
                    />
                </div>
            ) : (
                <div />
            )}
        </div>
    );
};
